import { schema } from 'normalizr'
import { Record, List, Map, fromJS } from 'immutable'
import { CurrencySchema } from './currencies'
import { FileSchema } from './files'
import { PlaceSchema } from './places'
import { OverrideSchema } from './overrides'
import { DEFAULT_AVAILABILITIES } from 'helpers/events'

export const EventSchema = new schema.Entity('events', {
  cover: FileSchema,
  currency: CurrencySchema,
  event_currency: CurrencySchema,
  files: [FileSchema],
  place: PlaceSchema,
  overrides: OverrideSchema,
  // user schema is linked in ./_utils.js due to circular dependencies
})

export const EventRecord = Record({
  tags: new List(),
  available_for_partners: undefined,
  begins_at: '',
  booking_deadline: undefined,
  cancellation_deadline: undefined,
  can_have_instant_bookings: undefined,
  created_at: undefined,
  cover: undefined,
  cover_id: undefined,
  currency: undefined,
  currency_id: undefined,
  description: '',
  descriptions: new List(),
  duration: undefined,
  ends_at: '',
  event_currency: undefined,
  event_currency_id: undefined,
  event_price: undefined,
  files: new List(),
  frozen_at: undefined,
  hosted_with: '',
  id: undefined,
  fees_rate: undefined,
  is_marriott: undefined,
  is_demo_event: undefined,
  is_star_chef: undefined,
  is_best_seller: undefined,
  is_online_experience: undefined,
  instant_booking: undefined,
  max_seats: undefined,
  masterchef_us: undefined,
  partner_only: false,
  pe_booking_deadline: undefined,
  pe_cancellation_deadline: undefined,
  default_availabilities: DEFAULT_AVAILABILITIES,
  metadata: fromJS({
    euro_pricing: {
      event_price: undefined,
    },
  }),
  next_date: new Map({
    date: undefined,
    available_seats: undefined,
    range_status: undefined,
  }),
  min_seats: undefined,
  overrides: undefined,
  price: undefined,
  place: undefined,
  place_id: undefined,
  allow_private_bookings: undefined,
  allow_public_bookings: undefined,
  privatized_by: undefined,
  properties: new Map(),
  published_at: undefined,
  status: '',
  title: '',
  type: '',
  localized_type: '',
  user: undefined,
  user_id: undefined,
  webpage_url: '',
  parent_id: undefined,
})

export const emptyEvent = new EventRecord()
